export const initialLabels = {
    checkout_proceedToCheckout_header: ' ',
    checkout_ifYouHaveAnAccount_message: ' ',
    checkout_loginViaMyYamaha_button: ' ',
    checkout_continueAsAGuest_header: ' ',
    checkout_paymentFee_label: '',
    checkout_paymentPayButton_message: '',
    checkout_dealersToolsHideDealers_button: '',
    productCard_controlMethod_label: '',
    checkout_shippingDetailsState_label: '',
    checkout_orderReviewDiscountCodeNotApplicable_error: '',
    checkout_shippingDetailsInternalCountry_label: '',
    checkout_dealersToolsShowDealers_button: '',
    checkout_shippingDetailsInternalCountry_error: '',
    common_preferredDealer_header: '',
    common_preferredDealer_description: '',
    checkout_billingAddressState_label: '',
    checkout_billingAddressInternalCountry_label: '',
    productCard_startingMethodAndTilt_label: '',
    productCard_shaftLength_label: '',
    checkout_accountWasDeactivated_message: '',
    checkout_deactivatedAccountDisclaimer_message: '',
    productCard_rotation_label: '',
    productCard_colorSelector_label: '',
    product_size_label: '',
    checkout_paymentFee_description: '',
    checkout_paymentError_alert: '',
    checkout_continueAsAGuest_button: ' ',
    checkout_yourEmail_label: ' ',
    checkout_enterYourEmail_placeholder: ' ',
    checkout_goBack_button: ' ',
    checkout_continue_button: ' ',
    checkout_incorrectEmail_error: ' ',
    checkout_createAccountLater_notification: '',
    checkout_signIn_label: '',
    checkout_ifYouAlreadyHaveAnAccountPlease_message: '',
    common_somethingWentWrong_message: ' ',
    checkout_dealerDeliveryConfirmationUnit_info: ' ',
    checkout_dealerDeliveryConfirmation_info: ' ',
    checkout_dealerDeliveryCostUnit_info: ' ',
    checkout_dealerDeliveryCost_info: ' ',
    checkout_dealerDeliveryTimeUnit_info: ' ',
    checkout_dealerDeliveryTime_info: ' ',
    checkout_dealerDelivery_title: ' ',
    checkout_freeDelivery_label: ' ',
    checkout_homeDeliveryConfirmationUnit_info: ' ',
    checkout_homeDeliveryConfirmation_info: ' ',
    checkout_homeDeliveryCostUnit_info: ' ',
    checkout_homeDeliveryCost_info: ' ',
    checkout_homeDeliveryTimeUnit_info: ' ',
    checkout_homeDeliveryTime_info: ' ',
    checkout_homeDelivery_title: ' ',
    checkout_cartIsActiveFor30Minutes_info: ' ',
    checkout_orderSummaryDiscount_label: ' ',
    checkout_orderSummaryOrderTotal_label: ' ',
    checkout_orderSummaryShipping_label: ' ',
    checkout_orderSummarySubtotal_label: ' ',
    checkout_orderSummary_header: ' ',
    checkout_personalDetailsCreateMyYamahaAccount_label: ' ',
    checkout_personalDetailsEmail_label: ' ',
    checkout_personalDetailsFirstName_label: ' ',
    checkout_personalDetailsFirstName_placeholder: ' ',
    checkout_personalDetailsLastName_label: ' ',
    checkout_personalDetailsLastName_placeholder: ' ',
    checkout_personalDetailsName_error: ' ',
    checkout_personalDetailsPhone_error: ' ',
    checkout_personalDetailsPhone_label: ' ',
    checkout_personalDetailsPhone_placeholder: ' ',
    checkout_personalDetailsRequiredField_error: ' ',
    checkout_personalDetailsSalutation_label: ' ',
    checkout_personalDetailsSalutation_placeholder: ' ',
    checkout_personalDetails_description: ' ',
    checkout_personalDetails_header: ' ',
    checkout_personalDetailsDealer_header: ' ',
    checkout_shippingMethod_header: ' ',
    checkout_shippingMethod_description: ' ',
    checkout_hero_header: ' ',
    checkout_heroStepInfo_label: ' ',
    checkout_heroShippingDetailsStep_title: ' ',
    checkout_heroOrderReviewStep_title: ' ',
    checkout_heroPaymentStep_title: ' ',
    checkout_heroThankYouStep_title: ' ',
    checkout_shoppingCartStep_title: ' ',
    checkout_shippingDetailsStep_title: ' ',
    checkout_orderReviewStep_title: ' ',
    checkout_paymentStep_title: ' ',
    checkout_shippingDetails_header: ' ',
    checkout_shippingDetails_description: ' ',
    checkout_shippingDetailsDeliveryAddress_label: ' ',
    checkout_shippingDetailsDeliveryAddress_hint: ' ',
    checkout_shippingDetailsAddress_label: ' ',
    checkout_shippingDetailsAddress_placeholder: ' ',
    checkout_shippingDetailsNoHouseNumber_label: ' ',
    checkout_shippingDetailsCity_label: ' ',
    checkout_shippingDetailsPostalCode_label: ' ',
    checkout_shippingDetailsAddress_error: ' ',
    checkout_shippingDetailsDeliveryAddress_placeholder: ' ',
    checkout_shippingDetailsCity_placeholder: ' ',
    checkout_shippingDetailsPostalCode_placeholder: ' ',
    checkout_preferredDealer_header: ' ',
    checkout_preferredDealer_description: ' ',
    checkout_preferredDealerLocationInput_label: ' ',
    checkout_preferredDealerLocationInput_placeholder: ' ',
    checkout_preferredDealerChooseFromMap_button: ' ',
    checkout_preferredDealerDealerListPagination_text: ' ',
    checkout_preferredDealerDealerCardPhone_label: ' ',
    checkout_preferredDealerDealerCardAddress_label: ' ',
    checkout_preferredDealerDealerCardDistance_label: ' ',
    common_km_label: ' ',
    checkout_billingAddress_description: ' ',
    checkout_billingAddressDifferentAddressOption_label: ' ',
    checkout_billingAddress_header: ' ',
    checkout_billingAddressPopUp_button: ' ',
    checkout_billingAddressPopUp_message: ' ',
    checkout_billingAddressPopUp_header: ' ',
    checkout_billingAddressShippingAddressOption_label: ' ',
    checkout_billingAddressWhatIsThis_link: ' ',
    checkout_billingAddressPostalCodeInput_placeholder: ' ',
    checkout_billingAddressPostalCodeInput_label: ' ',
    checkout_billingAddressNoBuildingNumberCheckbox_text: ' ',
    checkout_billingAddressCityInput_placeholder: ' ',
    checkout_billingAddressCityInput_label: ' ',
    checkout_billingAddressAddressSearchInput_placeholder: ' ',
    checkout_billingAddressAddressSearchInput_label: ' ',
    checkout_billingAddressAddressSearchInput_hint: ' ',
    checkout_billingAddressAddressInput_placeholder: ' ',
    checkout_billingAddressAddressInput_label: ' ',
    checkout_billingAddressAddressInputNoBuildingNumberError_text: ' ',
    checkout_changeStockErrorPopUp_header: ' ',
    checkout_changeStockErrorPopUp_message: ' ',
    checkout_personalDetailsCreateMyYamahaAccount_description: ' ',
    checkout_IUnderstand_button: ' ',
    checkout_orderReviewEnterDiscountCode_placeholder: '',
    checkout_orderReviewDiscountCodeNotAvailable_error: '',
    checkout_orderReviewDiscountCodeAlreadyApplied_error: '',
    checkout_orderReviewDiscountCodeNotActive_error: '',
    checkout_orderReviewEnterDiscountCode_error: '',
    checkout_orderReviewDiscountCodeApplied_message: '',
    checkout_preferredDealerFindDealerPopUp_header: '',
    checkout_preferredDealerFindDealerPopUpYourLocation_label: '',
    checkout_preferredDealerFindDealerPopUpSelectDealer_button: '',
    checkout_preferredDealerFindDealerPopUp_toast: '',
    checkout_preferredDealerFindDealerPopUpYourLocation_placeholder: '',
    checkout_santanderOutOfRange_message: '',
    checkout_santanderWrongLocation_message: '',
    common_tryAgain_label: '',
};
